module.exports = __webpack_public_path__ + "static/img/murf.09e21d4e.svg";